import React, { useMemo } from 'react';
import { Box } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import { FeatureFlags } from '../../../../../../components/Authorizer';
import { Authorizer } from '../../../../../../components/library';
import LoadingSpinner from '../../../../../../components/Spinner';
import { useInsuredActiveRecordsData } from '../../../../../../services/insured-service';
import {
  useRecordData,
  useRecordGptRequests,
  useRecordQuestionRequirements
} from '../../../../../../services/record-service';

import ActivityLog from './components/ActivityLog';
import DocumentRequirements from './components/DocumentRequirements';
import Items from './components/Items';
import PolicyRequirements from './components/PolicyRequirements';
import RecordAttachments from './components/RecordAttachments';

const RecordDetails = ({ companyId, insuredId, recordId }) => {
  const { data: activeRecordsData, isLoading } = useInsuredActiveRecordsData({ insuredId });
  const { data: recordData } = useRecordData(recordId);
  useRecordQuestionRequirements(recordId);
  useRecordGptRequests({ recordId });

  // temporary solution until we transition more api routes to record resource
  const jobId = useMemo(() => recordData?.job?.jobId, [recordData]);

  if (!recordId || !insuredId || !jobId) {
    return (
      <Box height="200px">
        <LoadingSpinner isInline minHeight="200px" />
      </Box>
    );
  }

  if (recordId && !isLoading && activeRecordsData.pages.length) {
    const { pages } = activeRecordsData;

    let recordIdPresent = false;

    for (let i = 0; i < pages.length; i += 1) {
      const page = pages[i];
      const { data: pageData } = page;

      if (pageData.find(record => recordId === record.id)) {
        recordIdPresent = true;
      }
    }

    if (!recordIdPresent) {
      return (
        <div>Please select a record</div>
      );
    }
  }

  return (
    <>
      <Authorizer featureFlag={FeatureFlags.Items}>
        <Items
          companyId={companyId}
          insuredId={insuredId}
          jobId={jobId}
          recordId={recordId}
        />
      </Authorizer>
      <PolicyRequirements
        companyId={companyId}
        insuredId={insuredId}
        jobId={jobId}
        recordId={recordId}
      />
      <DocumentRequirements
        companyId={companyId}
        insuredId={insuredId}
        jobId={jobId}
        recordId={recordId}
      />
      <RecordAttachments recordId={recordId} />
      <ActivityLog
        companyId={companyId}
        insuredId={insuredId}
        jobId={jobId}
        recordId={recordId}
      />
    </>
  );
};

RecordDetails.propTypes = {
  companyId: PropTypes.number.isRequired,
  insuredId: PropTypes.number.isRequired,
  recordId: PropTypes.number.isRequired
};

export default RecordDetails;
